import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { BaseService } from 'app/core/base.service';
import { ApiService } from './api.services';
import { Esteira } from '../models/esteira.model';
import { GerenciadorEmail } from '../models/gerenciadorEmail.model';
import { ViewModelEnviaCobranca } from '../models/enviaCobranca.model';
import { environment } from 'environments/environment';
import { ViewModelResultadoEnvio } from '../models/viewModelResultadoEnvio';
import { ViewModelEnviaCobrancaNovo } from '../models/enviaCobrancaNovo.model';

@Injectable()
export class GerenciadorEmailService {
 
    //private strAction = 'EnvioMensagemLote';
   
    constructor(
        httpClient: HttpClient,
        private http: HttpClient,
        private route: Router) {
       // super(httpClient, route);
        }
    deleteById(id: number) {
        throw new Error('Method not implemented.');
    }

         
        Post(viewModelEnviaCobrancaNovo: ViewModelEnviaCobrancaNovo) {    
            return this.http.post<void>(`${environment.TrustapiAreaRestrita}/`, viewModelEnviaCobrancaNovo);
        }

        getEnvioMensagemLote(data: string){
            return this.http.get<ViewModelResultadoEnvio>(`${environment.TrustapiAreaRestrita}EnvioMensagemLote/${data}`);
        }  
        
        getResultadoEnvio(vencimento: string){
            return this.http.get<ViewModelResultadoEnvio>(`${environment.TrustapiAreaRestrita}ResultadoEnvio/${vencimento}`);
        }
    
}